import { SearchDecryptionResponse } from 'src/sdk-servicing';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib/store';
import { SearchDecryptionModel } from './search-decryption.state';

/** StateDetailsActions */
const ACTION_SET = '[SearchDecryption] set';
const ACTION_UPDATE = '[SearchDecryption] update';
const ACTION_RESET = '[SearchDecryption] reset';
const ACTION_FAIL = '[SearchDecryption] fail';
const ACTION_CANCEL_REQUEST = '[SearchDecryption] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[SearchDecryption] set from api';
const ACTION_UPDATE_FROM_API = '[SearchDecryption] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setSearchDecryption = createAction(ACTION_SET, props<WithRequestId<SearchDecryptionModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateSearchDecryption = createAction(
  ACTION_UPDATE,
  props<WithRequestId<Partial<SearchDecryptionModel>>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetSearchDecryption = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelSearchDecryptionRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failSearchDecryption = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setSearchDecryptionFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<SearchDecryptionResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateSearchDecryptionFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<SearchDecryptionResponse>>()
);
